export enum EnumAlarmCategory {
  Aviso_Sistema = 0,
  Geocerca_Monitoreo  = 1,
  Geocerca_ValetParking = 2,
  Geocerca_Seguridad = 3,
  StatusGPS_ExcesoVelocidad = 4,
  StatusGPS_Desconectado = 5,
  StatusGPS_BajaSeñal = 6,
  StatusGPS_BateriaBaja = 7,
  UltAct_MasDe3Dias = 8,
  UltAct_MasDeUnaSemana = 9,
  UltAct_MasDeUnMes = 10
}

export enum EnumAlarmCategoriesValues {
  Aviso_Sistema = "Aviso del Sistema",
  Geocerca_Monitoreo = "Geocerca de Monitoreo",
  Geocerca_ValetParking = "Geocerca de Valet Parking",
  Geocerca_Seguridad = "Geocerca de Seguridad",
  StatusGPS_ExcesoVelocidad = "Exceso de Velocidad",
  StatusGPS_Desconectado = "Desconectado",
  StatusGPS_BajaSeñal = "Baja Señal",
  StatusGPS_BateriaBaja = "Batería Baja",
  UltAct_MasDe3Dias = "Más de 3 Días",
  UltAct_MasDeUnaSemana = "Más de 1 Semana",
  UltAct_MasDeUnMes = "Más de 1 Mes"
}

export enum EnumAlarmCategoriesIcons {
  Aviso_Sistema = "location_on",
  Geocerca_Monitoreo = "location_on",
  Geocerca_ValetParking = "location_searching",
  Geocerca_Seguridad = "warning",
  StatusGPS_ExcesoVelocidad = "warning",
  StatusGPS_Desconectado = "gps_off",
  StatusGPS_BajaSeñal = "signal_cellular_connected_no_internet_0_bar",
  StatusGPS_BateriaBaja = "battery_alert",
  UltAct_MasDe3Dias = "hourglass_empty",
  UltAct_MasDeUnaSemana = "hourglass_empty",
  UltAct_MasDeUnMes = "hourglass_empty"
}

export enum EnumAlarmCategoriesColors {
  Aviso_Sistema = "#2196F3",
  Geocerca_Monitoreo  = "#FFC107",
  Geocerca_ValetParking = "#FF9800",
  Geocerca_Seguridad = "#F44336",
  StatusGPS_ExcesoVelocidad = "#FF9800",
  StatusGPS_Desconectado = "#F44336",
  StatusGPS_BajaSeñal = "#FFC107",
  StatusGPS_BateriaBaja = "#FF9800",
  UltAct_MasDe3Dias = "#FFC107",
  UltAct_MasDeUnaSemana = "#FF9800",
  UltAct_MasDeUnMes = "#F44336"
}